import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Table from 'Components/table';
import fetchReport from 'Services/fetchReport';
import fetchShortUrl from 'Services/fetchShortUrl';
import util from 'Utils';
import ReactHtmlParser from 'react-html-parser';
import * as styles from './tableWrapper.css';

const { geosAsObject } = util;
const { isEquivalent } = util.obj;
const { getIndicatorIds } = util.array;

class TableWrapper extends Component {

  componentDidMount() {
    const { states, indicators, dispatch, print } = this.props;
    // If we have a print flag the localstore has the data!
    if (!print) {
      dispatch(fetchReport({ indicators, states }));
      dispatch(fetchShortUrl());
    }
  }

  componentWillUpdate(nextProps) {
    const { states, indicators, dispatch } = nextProps;
    const oldIndicators = this.props.indicators;
    const indicatorsEqual = (oldIndicators.length === indicators.length) &&
      oldIndicators.reduce((acc, val, idx) =>
        acc && isEquivalent(val, indicators[idx])
      , true);
    if (oldIndicators.length < indicators.length && !indicatorsEqual) {
      dispatch(fetchReport({ indicators, states }));
      dispatch(fetchShortUrl());
    }
  }

  render() {
    const { isFetching, error, loadingWarning } = this.props;
    if (isFetching || error) {
      return (
        <div className={styles.loadingPlaceholder}>
          <h4 className={styles.text}>
            {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                style={{
                  margin: 'auto',
                  background: 'rgb(255, 255, 255)',
                  display: 'block',
                  shapeRendering: 'auto',
                }}
                width="200px"
                height="200px"
                viewBox="0 0 100 100"
                preserveAspectRatio="xMidYMid"
              >
                <circle cx="50" cy="50" fill="none" stroke="#cccccc" strokeWidth="3" r="24" strokeDasharray="113.09733552923255 39.69911184307752" transform="rotate(142.134 50 50)">
                  <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1" />
                </circle>
              </svg>
            }
            {
              error ?
                'An error has occurred' : 'Please wait while we fetch data'
            }
          </h4>
          {
            loadingWarning && !error && (
              <p role="alert" className={styles.loadingWarning}>{ReactHtmlParser(loadingWarning)}</p>
            )
          }
          {
            error && (
              <p role="alert" className={styles.loadingError}>{ReactHtmlParser(error)}</p>
            )
          }
        </div>
      );
    }
    return (<Table />);
  }
}

TableWrapper.defaultProps = {
  isFetching: false,
  error: '',
  loadingWarning: '',
};

TableWrapper.propTypes = {
  print: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool,
  error: PropTypes.string,
  loadingWarning: PropTypes.string,
  states: PropTypes.arrayOf(
    PropTypes.string
  ).isRequired,
  indicators: PropTypes.arrayOf(
    PropTypes.object
  ).isRequired,
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = ({
  data: {
    categories,
    isFetching = true,
    indicators: collection = false,
    print,
    error,
    loadingWarning,
  },
  router,
}) => {
  const { geos, indicators } = router;
  const indicatorIds = getIndicatorIds(indicators);
  // Part of CDR-215.  Show all characteristic checkboxes regardless
  // of whether or not they are in the table.
  const getSiblings = (key, fullId) => {
    const parents =
      Object.keys(collection).filter((x) => collection[x].children)
        .filter((x) => collection[x].children.includes(+key));
    const children = [];
    parents.forEach((par) => {
      children.push(...collection[par].children);
    });

    // Get non-mega category siblings.
    if (fullId.includes('|')) {
      const catHash = fullId.split('|')[1];
      const foundCat = Object.values(categories)
        .find((cat) => cat.categoryHash === catHash);

      if (foundCat && foundCat.indicators.includes(+key)) {
        children.push(...foundCat.indicators);
      }
    }

    return children.filter((x) => x !== +key);
  };

  let states = null;
  if ('all' === geos) {
    states = Object.values(geosAsObject());
  } else {
    states = Array.isArray(geos) ?
      geos.map((geo) => geosAsObject()[geo]) :
      [geosAsObject()[geos]];
  }
  states = states.filter((state) => 'undefined' !== typeof state);
  return ({
    print,
    states,
    isFetching,
    error,
    loadingWarning,
    indicators: Array.isArray(indicators) ?
      // Get the data for the siblings as well.  Not the most
      // performant solution.  We'll get all the characteristics
      // of the siblings as well as the desired indicator.
      // We'll use these later on when rendering the refine data
      // toolbox.
      indicatorIds.reduce((acc, key, index) => [
        { key: collection[key].gdocs_key,
          activeYear: 'undefined' !== typeof router[indicators[index]] ?
            router[indicators[index]].year :
            undefined },
        ...getSiblings(key, indicators[index]).map((sibling) => ({
          key: collection[sibling].gdocs_key,
        })),
        ...acc,
      ], []) :
    [{ key: collection[indicatorIds].gdocs_key,
      activeYear: 'undefined' !== typeof router[indicators[0]] ?
        router[indicators[0]].year :
        undefined }],
  });
};

export default connect(
  mapStateToProps,
)(TableWrapper);

// Testing exports
export {
  TableWrapper,
  mapStateToProps,
};



// WEBPACK FOOTER //
// ./app/components/tableWrapper/index.js